import React, { useEffect, useContext } from "react"
import {
  Box,
} from "@chakra-ui/react"
import { Tabs, TabList, TabPanels, Tab, TabPanel, TabIndicator } from '@chakra-ui/react'
import { GlobalContextProvider } from "../components/functions/GlobalContext"
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CountryStats from "../components/CountryStats"
import MedalStats from "../components/MedalStats"

export default function ReportsPage() {
  const globalContext = useContext(GlobalContextProvider)
  const { t, i18n } = useTranslation();
  const navigate = useNavigate()

  useEffect(() => {
    let username = globalContext?.GetLoginData().username || ""
    if (username === "") {
      navigate('/login')
    }
  }, [])

  return (
    <Box py={"10px"} px={"10px"} maxW='m' borderWidth='0px' borderRadius='lg' overflow='hidden'>

      <Tabs variant={"enclosed-colored"}>
        <TabList>
          <Tab>{t('General Stats')}</Tab>
          <Tab>{t('Medal')}</Tab>
        </TabList>
        <TabIndicator
          mt="-1.5px"
          height="2px"
          bg="blue.500"
          borderRadius="1px"
        />
        <TabPanels>
          <TabPanel>
            <CountryStats />
          </TabPanel>
          <TabPanel>
            <MedalStats />
          </TabPanel>
        </TabPanels>
      </Tabs>

    </Box>
  )
}
